import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimContractObjectCreateInput } from 'gql/graphql';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { bimCreateWorkOrderChangeObjectGql } from '../bimWorkOrderChangeStructureQueries';

const requestId = 'bimCreateWorkOrderObjectChange';

export const useBimCreateWorkOrderObjectChange = (workOrderChangeId?: number, onSuccess?: () => void) => {
    const dispatch = useDispatch();

    const [bimCreateWorkOrderObjectReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        bimCreateWorkOrderObjectReset(undefined);
        onSuccess?.();
    }, [bimCreateWorkOrderObjectReset, onSuccess]);

    const [
        bimCreateWorkOrderObjectChangeData,
        bimCreateWorkOrderObjectChangeStatus,
        bimCreateWorkOrderObjectChangeError,
        bimCreateWorkOrderObjectChangeRequest,
    ] = useRequest({
        requestId,
        query: bimCreateWorkOrderChangeObjectGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    const bimCreateWorkOrderObjectChangeMakeRequest = useCallback(
        (input: BimContractObjectCreateInput) => {
            dispatch(bimCreateWorkOrderObjectChangeRequest({ workOrderChangeId, input }));
        },
        [bimCreateWorkOrderObjectChangeRequest, dispatch, workOrderChangeId],
    );

    useEffect(() => {
        bimCreateWorkOrderObjectReset(undefined);
    }, [bimCreateWorkOrderObjectReset]);

    return {
        bimCreateWorkOrderObjectChangeData,
        bimCreateWorkOrderObjectChangeStatus,
        bimCreateWorkOrderObjectChangeError,
        bimCreateWorkOrderObjectChangeMakeRequest,
    };
};
